import { createStore } from 'vuex';
import main from './modules/main';
import localforage from 'localforage';

export const DB_NAME = "pwaf-pwa";
export const DB_STORE_NAME = "app_data";

const params = window.location.search;

let hostUrl;
let themeHostUrl;
let dbStartUrl;
if (process.env.NODE_ENV === "development") {
	hostUrl = `http://localhost:8080${params}`;
	themeHostUrl = "http://localhost:3000/theme";
	dbStartUrl = "http://localhost:3000/dbservice/start";
} else {
	hostUrl = `/${params}`;
	themeHostUrl = "/DBService/service.htm?type=theme";
	dbStartUrl = `/DBService/service.htm${params}`;
}


export const HOST_URL = hostUrl;
export const DBSERVICE_START_URL = dbStartUrl;
export const THEME_HOST_URL = themeHostUrl;

localforage.config({
	name: DB_NAME,
	storeName: DB_STORE_NAME
});

export default createStore({
	modules: {
		main,
	},
	strict: true
});

